import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { ArgoConnectionKindEnum } from '@redviking/argonaut-util/types/db-enums/argo/connection_kind';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const mqttPublishNodeSpec: NodeSpec<NodeCfg<'mqttPublish'>> = {
    requiredSockets: [ 'trigger', 'topic', 'payload' ],
    cfg: () => ({
        id: getUID(),
        disabled: false,
        kind: 'mqttPublish',
        width: 220,
        controlValues: {
            connectionId: '',
            qos: 0,
            retain: true,
        },
    }),
    controls: nodeCfg => ({
        connectionId: defineControlOpts({
            cfg: {
                kind: 'connectionSelect',
                label: 'Connection',
                allowedConnectionKinds: [ ArgoConnectionKindEnum.MqttBroker ],
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.connectionId,
        }),
        qos: defineControlOpts({
            cfg: {
                kind: 'selection',
                items: [
                    { label: '0', value: 0 },
                    { label: '1', value: 1 },
                    { label: '2', value: 2 },
                ],
                label: 'QoS',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.qos,
        }),
        retain: defineControlOpts({
            cfg: { kind: 'boolean', label: 'Retain' },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.retain,
        }),
    }),
    inputs: nodeCfg => ({
        trigger: { socket: 'event', label: 'Trigger' },
        payload: {
            controlOpts: defineControlOpts({
                cfg: { kind: 'text' },
                on: { 'update:value': defaultControlUpdateValueHandler },
                enableWithConnectedSocket: false,
                value: nodeCfg.socketDefaults?.inputs?.payload || '',
            }),
            socket: 'varValue',
            label: 'Message',
        },
        topic: {
            socket: 'string',
            label: 'Topic',
            controlOpts: defineControlOpts({
                cfg: { kind: 'text' },
                on: { 'update:value': defaultControlUpdateValueHandler },
                enableWithConnectedSocket: false,
                value: nodeCfg.socketDefaults?.inputs?.topic || '',
            }),
        },
    }),
    kindLabel: 'MQTT Publish',
    nodeCategory: 'connection',
    nodeSubCategory: 'MQTT',
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    validator: () => true,
};
